module.exports = __webpack_public_path__ + "img/error.67dbd04a.png";